import createVueComponent from '../createVueComponent';

const MoreHorizontal = createVueComponent('MoreHorizontalIcon', [
  ['circle', { cx: '12', cy: '12', r: '1' }],
  ['circle', { cx: '19', cy: '12', r: '1' }],
  ['circle', { cx: '5', cy: '12', r: '1' }],
]);

export default MoreHorizontal;
